(ns frontend.ui.page.lp-report-editor.step-1-initialization.event
  (:require
   [re-frame.core :as rf]
   [frontend.routing :as routing]
   [frontend.controller.websocket.event :as ws]
   [potpuri.core :as p]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.component.file-input.event :as file-event]
   [frontend.ui.page.lp-report-editor.step-1-initialization.sub :as sub]
   [common.time :as c-time]
   [cljs-uuid-utils.core :as uuid]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(rf/reg-event-fx
 ::close-edit-mode
 (fn [{db :db} [_ step]]
   {:db (assoc-in db (conj sub/edit-path step) false)}))

(rf/reg-event-fx
 ::open-edit-mode
 (fn [{db :db} [_ step]]
   {:db (-> db
            (assoc-in (conj sub/edit-path step) true)
            (assoc-in (conj sub/collapse-path step) false))}))

(rf/reg-event-fx
 ::toggle-collapse
 (fn [{db :db} [_ step]]
   {:db (update-in db (conj sub/collapse-path step) not)}))

(rf/reg-event-fx
 ::hide-change-template-dialog
 (fn [{db :db} _]
   {:db (p/dissoc-in db sub/template-change-dialog-path)}))

(rf/reg-event-fx
 ::start-change-template-type
 (fn [{db :db} _]
   {:db (assoc-in db sub/template-change-dialog-path true)}))

(rf/reg-event-fx
 ::basic-change-completed
 (fn [{db :db} _]
   {:fx [[:dispatch [::close-edit-mode :step-1]]
         [:dispatch [::open-edit-mode :step-2]]]}))

(rf/reg-event-fx
 ::hide-delete-dialog
 (fn [{db :db} _]
   {:db (p/dissoc-in db sub/delete-dialog-path)}))

(rf/reg-event-fx
 ::start-delete-cycle
 (fn [{db :db} _]
   {:db (assoc-in db sub/delete-dialog-path true)}))

(rf/reg-event-fx
 ::lp-report-disabled-ok
 (fn [{db :db} [_ report resp]]
   {:db (p/dissoc-in db editor-sub/editor-path)
    ::routing/old-routing {:path-args [:entity.type/fund :id (:lp-report/fund report)]}}))

(rf/reg-event-fx
 ::disable-lp-report
 (fn [{db :db} [_ report]]
   {:db       (assoc-in db sub/delete-dialog-processing-path true)
    ::ws/send {:id         :entity/disable!
               :body       {:entity-id (:db/id report)}
               :on-success [::lp-report-disabled-ok report]
               :on-error   [::lp-report-disable-failed]}}))

(rf/reg-event-fx
 ::process-fund-report-file
 (fn [{db :db} [_ report-id file-id]]
   {::ws/send {:id         :lp-report/process-fund-data
               :body       {:report-id     report-id
                            :attachment-id file-id}
               :on-success [::editor-event/re-load-editor-data
                            report-id
                            [::editor-event/reload-fund-data-progress report-id]]
               :on-error   [::editor-event/lp-fund-report-data-file-update-failed]}}))

(rf/reg-event-fx
 ::saved-holdings
 (fn [{db :db} _]
   {:db (-> db
            (assoc-in sub/holdings-processing-path false)
            (p/dissoc-in sub/holdings-config-path)
            (p/dissoc-in (conj sub/edit-path :step-3)))}))

(rf/reg-event-fx
 ::save-holdings-failed
 (fn [{db :db} [_ err]]
   {:db (assoc-in db sub/holdings-processing-path false)}))

(rf/reg-event-fx
 ::save-holdings
 (fn [{db :db} [_ retracts additions]]
   (let [ids (set (concat (keys retracts) (keys additions)))
         editable-keys [:lp-report-holding/template-type
                        :lp-report-holding/data-contributors
                        :lp-report-holding/text-contributors
                        :lp-report-holding/text-approver
                        :lp-report-holding/data-approver
                        :lp-report-holding/name]
         report-id (:db/id (get-in db editor-sub/report-path))
         holding-config (get-in db sub/holdings-config-path)
         changes (->> ids
                      (map (fn [id]
                             (merge {:db/id id}
                                    (->> (select-keys (get retracts id) editable-keys)
                                         (keys)
                                         (map (fn [k]
                                                [k nil]))
                                         (into {}))
                                    (select-keys (get additions id) editable-keys)
                                    {:lp-report-holding/chart-editor-roles (:lp-report-holding/chart-editor-roles
                                                                             (get holding-config id))}
                                    {:lp-report-holding/chart-selector-roles (:lp-report-holding/chart-selector-roles
                                                                               (get holding-config id))})))
                      (doall))]
     {:db       (assoc-in db sub/holdings-processing-path true)
      ::ws/send {:id         :lp-report-holding/save-holdings
                 :body       {:report-id       report-id
                              :holding-updates changes}
                 :on-success [::editor-event/re-load-editor-data
                              report-id
                              [::saved-holdings]]
                 :on-error   [::save-holdings-failed]}})))

(rf/reg-event-fx
 ::add-holding
 (fn [{db :db} _]
   (let [new-holding-temp-id (str "holding-" (c-time/now-millis))]
     {:db (assoc-in db
           (concat sub/holdings-config-path [new-holding-temp-id])
           {:db/id new-holding-temp-id
            :lp-report-holding/name ""})})))

(rf/reg-event-fx
 ::start-fund-file-upload
 (fn [{db :db} [_ file]]
   (let [report (get-in db [:lp-report-editor :lp-report])
         report-id (:db/id report)
         upload-descriptor {:file  file
                            :owning-entity-id report-id
                            :token nil}]
     {:db (-> db
              (assoc-in [:lp-report-editor :lp-report :lp-report/report-data-status]
                        {:processing-status :status/uploading
                         :file-name (.-name file)
                         :progress 1
                         :progress-message-kw :uploading}))
      :dispatch [::file-event/upload-file-socket
                 editor-sub/report-path
                 [:lp-report-editor :lp-report-attachments]
                 [::editor-event/process-fund-report-file report]
                 nil
                 upload-descriptor]})))

(rf/reg-event-fx
 ::add-feeder
 (fn [{db :db} _]
   (let [temp-id (->> (uuid/make-random-uuid)
                      (uuid/uuid-string))]
     ;; ONLY single feeder for now
     (when (empty? (get-in db sub/feeder-config-path))
       {:db (assoc-in db
             (conj sub/feeder-config-path temp-id)
             {:db/id       temp-id
              :entity/type :entity.type/lp-report})}))))

(rf/reg-event-fx
 ::removed-feeder
 (fn [{db :db} [_ feeder-id]]
   {:db (-> db
            (p/dissoc-in (conj sub/feeder-config-path feeder-id)))}))

(rf/reg-event-fx
 ::remove-feeder-failed
 (fn [{db :db} [_ err]]
   {:db (assoc-in db sub/feeders-processing-path false)}))

(rf/reg-event-fx
 ::remove-feeder
 (fn [{db :db} [_ feeder-id]]
   (let [report-id (:db/id (get-in db editor-sub/report-path))]
     {:db       (assoc-in db sub/feeders-processing-path true)
      ::ws/send {:id         :lp-report/remove-feeder
                 :body       {:main-report-id report-id
                              :feeder-id      feeder-id}
                 :on-success [::editor-event/re-load-editor-data
                              report-id
                              [::removed-feeder feeder-id]]
                 :on-error   [::remove-feeder-failed feeder-id]}})))

(rf/reg-event-fx
 ::reset-feeders
 (fn [{db :db} _]
   {:db (p/dissoc-in db sub/feeder-config-path)}))

(rf/reg-event-fx
 ::init-feeders
 (fn [{db :db} _]
   (let [report-feeders (get-in db editor-sub/feeder-reports-path)
         report-feeders-map (->> report-feeders
                                 (map (fn [f]
                                        [(:db/id f) f]))
                                 (into {}))]
     {:db (assoc-in db sub/feeder-config-path report-feeders-map)})))


(rf/reg-event-fx
 ::feeder-change
 (fn [{db :db} [_ feeder-id attribute new-value]]
   {:db (assoc-in db (concat sub/feeder-config-path [feeder-id attribute]) new-value)}))

(rf/reg-event-fx
 ::saved-feeders
 (fn [{db :db} _]
   {:db (-> db
            (assoc-in sub/holdings-processing-path false)
            (p/dissoc-in sub/holdings-config-path)
            (p/dissoc-in (conj sub/edit-path :step-3)))
    :fx [[:dispatch [::close-edit-mode :step-4]]]}))

(rf/reg-event-fx
 ::save-feeders-failed
 (fn [{db :db} [_ err]]
   {:db (assoc-in db sub/feeders-processing-path false)}))

(rf/reg-event-fx
 ::save-feeders
 (fn [{db :db} [_ retracts additions]]
   (let [ids (set (concat (keys retracts) (keys additions)))
         editable-keys [:lp-report/fund
                        :lp-report/title
                        :lp-report/process-owners
                        :lp-report/text-contributors
                        :lp-report/data-contributors
                        :lp-report/final-approver
                        :lp-report/followers
                        :lp-report/text-approver
                        :lp-report/data-approver
                        :lp-report/template-type]
         report-id (:db/id (get-in db editor-sub/report-path))
         changes (->> ids
                      (map (fn [id]
                             (merge {:db/id id}
                                    (->> (select-keys (get retracts id) editable-keys)
                                         (keys)
                                         (map (fn [k]
                                                [k nil]))
                                         (into {}))
                                    (select-keys (get additions id) editable-keys))))
                      (doall))]
     {:db       (assoc-in db sub/feeders-processing-path true)
      ::ws/send {:id         :lp-report/save-feeders
                 :body       {:main-report-id report-id
                              :changes        changes}
                 :on-success [::editor-event/re-load-editor-data
                              report-id
                              [::saved-feeders]]
                 :on-error   [::save-feeders-failed]}})))

(rf/reg-event-fx
 ::reset-holdings
 (fn [{db :db} _]
   {:db (p/dissoc-in db sub/holdings-config-path)}))

(rf/reg-event-fx
 ::init-holdings
 (fn [{db :db} _]
   (let [report (get-in db editor-sub/report-path)
         report-holdings (->> report
                              :lp-report/holdings
                              (map (fn [holding-id]
                                     [holding-id
                                      (get-in db (conj editor-sub/holdings-path holding-id))]))
                              (sort-by (fn [[id entity]]
                                         (:common/ord entity)))
                              (into {}))]
     {:db (assoc-in db sub/holdings-config-path report-holdings)})))

(rf/reg-event-fx
 ::holding-change
 (fn [{db :db} [_ holding-id attribute new-value]]
   {:db (assoc-in db (concat sub/holdings-config-path [holding-id attribute]) new-value)}))

(rf/reg-event-fx
 ::start-basic-edit
 (fn [{db :db} _]
   {:db (assoc-in db sub/basic-config-path (get-in db editor-sub/report-path))
    :fx [[:dispatch [::open-edit-mode :step-1]]]}))

(rf/reg-event-fx
 ::basic-change
 (fn [{db :db} [_ attribute new-value]]
   {:db (assoc-in db (conj sub/basic-config-path attribute) new-value)}))

(rf/reg-event-fx
 ::begin-report-cycle
 (fn [_ [_ report-id]]
   {::ws/send {:id         :lp-report/begin-cycle
               :body       {:report-id report-id}
               :on-success [::editor-event/re-load-editor-data report-id
                            [::editor-event/activate-report-step report-id]]
               :on-error   [::begin-report-failed report-id]}}))

(rf/reg-event-fx
 ::remove-fund-config-file
 (fn [{db :db} [_ report-id attachment-id]]
   {::ws/send {:id         :lp-report/remove-fund-data
               :body       {:report-id     report-id
                            :attachment-id attachment-id}
               :on-success [::editor-event/re-load-editor-data report-id nil]
               :on-error   [::remove-fund-config-file-failed report-id]}}))
